/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1      Usha       24/01/2020      1973: Related Symptoms Implementation
CHID-2      Usha       13/02/2020      2526: Symptoms Selector (NON NLP)
*********************************************************************************/
import { classnames as cx } from "@mna/react";
import IconCheckmark from "assets/icons/checkmark.svg";
import careOptionsSteps from "../steps";
import IconAdd from "assets/icons/add.svg";
import { Trans } from "react-i18next";
import LoadingScreen from '../../../features/LoadingScreen'
import i18n from "./../../../i18n";
import {checkAndGetLocalStorageValue } from "../../../features/utils"
let lang = i18n.language;
let isQuestionLog;

//CHID-1 Start
async function RelatedSymptomCallback(
  state,
  nextStepName,
  history,
  actions,
  setState
) {
  if (state.RelatedSymptomInfo.length > 0) {
    state.triageRequest.RelatedSymptoms = state.RelatedSymptomInfo;
    setState({
      isLoading_RelativeSymptom: false,
    });
    state.triageRequest.activeMenu = nextStepName;
    history.push(`/find-care-options/${nextStepName}`);
  } else {
    actions.clearQuestionsState();
    for (let i = 0, len = careOptionsSteps.length - 1; i < len; i++) {
      const { name } = careOptionsSteps[i];
      if (name === nextStepName) {
        nextStepName =
          careOptionsSteps[i].next || (careOptionsSteps[i + 1] || {}).name;
        break;
      }
    }

    await actions.getQuestions(
      { state, actions, setState, nextStepName, history },
      (lang = i18n.language),
      (isQuestionLog = false)
    );
  }
} //CHID-1 End
export default ({
  state,
  actions,
  history,
  previousStepName,
  nextStepName,
  setState,
  getState,
}) =>{
 
return (
  <div
    className="article-width flex flex-column full-height"
    style={{ maxWidth: "620px" }}
  >
     <LoadingScreen isLoading={state.isLoading_PrioritySymptom}>
    <div
      className="flex-grow selected-symptom-list"
      style={{ overflowY: "auto" }}
    >
      <h1 className="text-left standby-page-header-title mt-2 mb-3" tabIndex="0">
        <Trans i18nKey="findcareoption.SymptomSelector.Sel_Symptoms1">
          Selected Symptoms
        </Trans>
      </h1>
      <p>
        <Trans i18nKey="findcareoption.SymptomSelector.symprioritysubhead">
          Please review your reported symptoms, if you are done adding symptoms
          please click "Next" or click the green icon below to ad d/edit
          selected symptoms.
        </Trans>
      </p>

      <div className="text-left mt-1">
        {state.currentSymptomsSortedKeys.map((key) => (
          <div
            key={`symptom-added-${state.currentSymptomsMap[key].id}`}
            className="inline symptom-select-primary"
          >
            <text
              tabIndex="0"
              aria-label={state.currentSymptomsMap[key].common_name}
              className={cx(
                "symptom-button symptom-select-primary-button btn btn-pill no-border mt-1 mr-1",
                state.primarySymptom === state.currentSymptomsMap[key].id
                  ? "selected"
                  : "selected"
              )}
              onClick={() => {
                actions.setPrimarySymptom({
                  primarySymptom: state.currentSymptomsMap[key].id,
                });
              }}
            >
              <div className="symptom-text">
                {state.currentSymptomsMap[key].common_name}
              </div>
              <div className="icon icon-priority-symptom"  id={state.currentSymptomsMap[key].id}>
                <IconCheckmark id={state.currentSymptomsMap[key].common_name} />
              </div>
            </text>
          </div>
        ))}
      </div>
      {/*CHID-2 Start*/}
      <div className="standby-btn-edit">
        {" "}
        <button
          type="button"
          onClick={(e) => {
            setState({
              showNLPModal: true,
              symptomsAdded: [],
            });
            const obj = { name: "symptoms", previous: "location" }
            state.triageRequest.activeMenu = obj.name;
            history.push(`/find-care-options/${obj.name}`);
          }}
          className="button standby-symptom-button standby-symptom-button-add"
        >
          <div className="standby-symptom-button-text">
            <Trans i18nKey="findcareoption.SymptomSelector.add_Symptoms">
              Edit or add more Symptoms
            </Trans>
          </div>
          <div className="icon icon-add-symptom">
            <IconAdd />
          </div>
        </button>
      </div>
      {/*CHID-2 End*/}
    </div>
    <div className="mt-2">
      {!state.primarySymptom ? (
        <button
          type="button"
          className="button standby-button standby-button-gradient standby-button-full-width standby-button-disabled"
          disabled
        >
          <Trans i18nKey="findcareoption.SymptomSelector.Next">Next</Trans>
        </button>
      ) : (
        <button
          type="button"
          className="button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green"
          onClick={async() => {
            let lang = i18n.language;
            state.orderIdArray = [];
            setState({
              isLoading: true,
              isLoading_PrioritySymptom:true
            });            
            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));

            await actions.submitTriageSymptoms(lang);
            
            await actions.getRelatedSymptoms({
              RelatedSymptomCallback,
              nextStepName,
              history,
              getState,
              lang,
              actions,
            }); //CHID1 -1973
          }}
        >
          <Trans i18nKey="findcareoption.SymptomSelector.Next">Next</Trans>
        </button>
      )}
    </div>
    </LoadingScreen></div>
)};
